import React from "react";

const Flex = React.forwardRef(({
  className,
  flexitem,
  end,
  itemsstart,
  itemsend,
  spacing,
  vertical,
  shape,
  itemscenter,
  center,
  wrap,
  out,
  in: flexIn,
  margin,
  padding,
  id,
  style,
  onClick,
  children,
  ...rest
}, ref) => {
  const classes = [
    "ta-flex",
    className,
    flexitem && "ta-flexitem",
    end && "ta-flex--end",
    itemsstart && "ta-flex--itemsstart",
    itemsend && "ta-flex--itemsend",
    spacing && "ta-gap_" + spacing,
    vertical && "ta-flex--column",
    shape && "ta-shape_radius-" + shape,
    itemscenter && "ta-flex--itemscenter",
    center && "ta-flex--center",
    wrap && "ta-flex--wrap",
    out && "ta-flex--out",
    flexIn && "ta-flex--in",
    margin && "ta-margin_" + margin,
    padding && "ta-padding_" + padding,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      ref={ref}
      id={id}
      className={classes}
      style={style}
      onClick={onClick}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Flex;

export const FlexItem = React.forwardRef(({ className, children, id, style, ...rest }, ref) => {
  const classes = ["ta-flexitem", className].filter(Boolean).join(" ");

  return (
    <div ref={ref} id={id} className={classes} style={style} {...rest}>
      {children}
    </div>
  );
});
